import {initChatListener} from "../swissactivities";

initChatListener();